import { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { NavItemInterface } from 'widgets/NavBar/NavItem';

import { selectPathname } from 'rdx/router';

import { MenuContext } from './navStructureUtils';
import { parseUrlLocation } from './parseUrlLocation';

export const useBreadcrumbs = (): { breadcrumbsItems: NavItemInterface[] } => {
  const pathname = useSelector(selectPathname);
  const [breadcrumbsItems, setBreadcrumbsItems] = useState<NavItemInterface[]>([]);

  const menuCategories = useContext(MenuContext)?.menu;

  useEffect(() => {
    const { category, item } = parseUrlLocation(pathname, menuCategories);

    // we build breadcrumbs array only if we have category and subcategory
    if (category && item) {
      setBreadcrumbsItems([category, item]);
    } else {
      setBreadcrumbsItems([]);
    }
  }, [pathname, menuCategories]);

  return { breadcrumbsItems };
};
